import React, {Component} from 'react';
import CeoHeader from "./Header";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Link} from "react-router-dom";
import '../style/letter-stylev3.min.css';
import { isWebView } from '../../commons/CommonFunctions';

class CeoDesk extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentDidMount() {
        document.title='Amit Banka CEO WeNaturalists | A journey that has just begun!'
    }

    render() {
        return (
            <>
              <CeoHeader goBackButtn={this.props.isBackWebPage ? this.props.goBackButtn : this.props.history.goBack} isBackWebPage={true}>
                <div className="dgcontainer">
                    <div className="banner_bg">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 hedtTTl">
                                <h1 className="text-center">CEO's Desk</h1>
                                <h2 className="text-center">The Journey that has just begun!</h2>
                            </div>
                            <div className="col-md-4">
                                <a className="letreach_block"
                                   href={'/ceo-desk/the-story-behind-our-passion'}>
                                    <div className="letrimg_bx">
                                        <LazyLoadImage effect="blur" src="https://cdn.dscovr.com/images/blog-cover_img-1.webp"
                                                       onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/blog-cover_img-1.png"}} alt=""/>
                                    </div>
                                    <div className="block_desc">
                                        <p>The Story Behind Our Passion</p>
                                    </div>
                                </a>
                            </div>
                            <div className="col-md-4">
                                <a className="letreach_block"
                                   href={'/ceo-desk/this-is-how-it-all-began'}>
                                    <div className="letrimg_bx">
                                        <LazyLoadImage effect="blur" src="https://cdn.dscovr.com/images/blog-cover_img-2v1.webp"
                                                       onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/blog-cover_img-2v1.png"}} alt=""/>
                                    </div>
                                    <div className="block_desc">
                                        <p>And this is how it all began!</p>
                                    </div>
                                </a>
                            </div>
                            <div className="col-md-4">
                                <a className="letreach_block"
                                   href={'/ceo-desk/building-an-impactful-world'}>
                                    <div className="letrimg_bx">
                                        <LazyLoadImage effect="blur" src="https://cdn.dscovr.com/images/blg3poster.webp"
                                                       onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/blg3poster.png"}} alt=""/>
                                    </div>
                                    <div className="block_desc">
                                        <p>Building an Impactful World for the People-of-Nature</p>
                                    </div>
                                </a>
                            </div>
                            <div className="col-12 bottom_desk">
                                <div className="letr_title">
                                    <h4>
                                        <span>Amit Banka, 
                                            <span>CEO {!isWebView() ? <Link to={'/'}>WeNaturalists</Link> : <span>WeNaturalists</span>}
                                            </span>
                                        </span>
                                    </h4>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="letr_shreBx">
                                    <ul className="lertsocial_share">
                                        <li>
                                            <a href="https://www.linkedin.com/company/wenaturalists" target="_blank"><i
                                                className="iSocial_LinkedIn"></i></a>
                                        </li>
                                        <li>
                                            <a href=" https://www.instagram.com/WeNaturalists/" target="_blank"><i
                                                className="iSocial_Instagram"></i></a>
                                        </li>
                                        <li>
                                            <a href=" https://twitter.com/WeNaturalists" target="_blank"><i
                                                className="iSocial_Twitter"></i></a>
                                        </li>
                                        <li>
                                            <a href="https://www.facebook.com/WeNaturalists/" target="_blank"><i
                                                className="iSocial_FB"></i></a>
                                        </li>
                                        <li>
                                            <a href="https://www.youtube.com/channel/UCUFUqiJGKl9nj_v6fcbsTnw?view_as=subscriber"
                                               target="_blank"><i className="iYouTube_Logo"></i></a>
                                        </li>
                                        <li>
                                            <a href="https://medium.com/wenaturalists" target="_blank"><i
                                                className="iSocial_Medium"></i></a>
                                        </li>
                                        <li>
                                            <a href=" https://in.pinterest.com/WeNaturalists/" target="_blank"><i
                                                className="iSocial_Pinterest"></i></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
              </CeoHeader>
            </>
        );
    }
}

export default CeoDesk;